﻿function initAboutLeadershipTeam() {
    //this is just an example plugin that allows us to animate a "blur" property like gsap.to(target, {blur:10}) and it'll feed that value to this plugin which will do all the necessary calculations to add/update a blur() value in the CSS "filter" property (in browsers that support it). We wrap it in an iife just so that we can declare some local variables in a private scope at the top.
    (function () {
        const blurProperty = gsap.utils.checkPrefix("filter"),
            blurExp = /blur\((.+)?px\)/,
            getBlurMatch = (target) =>
                (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

        gsap.registerPlugin({
            name: "blur",
            get(target) {
                return +getBlurMatch(target)[1] || 0;
            },
            init(target, endValue) {
                let data = this,
                    filter = gsap.getProperty(target, blurProperty),
                    endBlur = "blur(" + endValue + "px)",
                    match = getBlurMatch(target)[0],
                    index;
                if (filter === "none") {
                    filter = "";
                }
                if (match) {
                    index = filter.indexOf(match);
                    endValue =
                        filter.substr(0, index) +
                        endBlur +
                        filter.substr(index + match.length);
                } else {
                    endValue = filter + endBlur;
                    filter += filter ? " blur(0px)" : "blur(0px)";
                }
                data.target = target;
                data.interp = gsap.utils.interpolate(filter, endValue);
            },
            render(progress, data) {
                data.target.style[blurProperty] = data.interp(progress);
            }
        });
    })();

    const headshots = gsap.utils.toArray(".leadershipCard"),
        expandedContainer = document.querySelector(".leadershipExpandedContainer"),
        expandedBioContainer = document.querySelector(
            ".leadershipExpandedContainer__bio"
        ),
        expandedImage = document.querySelector(
            ".leadershipExpandedContainer__headshot img"
        ),
        expandedName = document.querySelector(
            ".leadershipExpandedContainer__bio .name"
        ),
        expandedTitle = document.querySelector(
            ".leadershipExpandedContainer__bio .title"
        ),
        expandedBio = document.querySelector(
            ".leadershipExpandedContainer__bio .bio"
        ),
        expandedSocial = document.querySelector(
            ".leadershipExpandedContainer__bio .social"
        ),
        expandedLearnMore = document.querySelector(
            ".leadershipExpandedContainer__bio .learnMore"
        );

    let activeHeadshot;

    gsap.set(expandedBioContainer, { xPercent: 15, opacity: 0 });

    function expandHeadshot(card) {
        //If someone clicks on element behind expanded headshot, then we should
        //just close the currently expanded headshot
        if (activeHeadshot) {
            return closeHeadshot();
        }

        //If we're on a small screen, just return. The bios are expanded via css
        if (window.innerWidth < 800) {
            return;
        }

        //Prevent scrolling
        gsap.set('body', { overflow: 'hidden' });

        //When the image in the detail DOM is loaded, we run the GSAP flip stuff.
        //Anything outside this function isn't related to FLIPing the headshot
        const onload = () => {
            //Position the expanded container on top of the headshot.
            //Make sure to use fitChild on the image so that's what looks like
            //it's growing.
            Flip.fit(expandedContainer, card.querySelector("img"), {
                scale: true,
                fitChild: expandedImage
            });

            //Record the state that everything is in.
            const state = Flip.getState(expandedContainer);

            //Set the final state
            gsap.set(expandedContainer, { clearProps: true });
            gsap.set(expandedContainer, { visibility: "visible" });

            Flip.from(state, {
                duration: 0.45,
                scale: true,
                ease: "power2.in",
                absolute: true
            }).to(expandedBioContainer, { xPercent: 0, opacity: 1, duration: 0.25 });

            expandedImage.removeEventListener("load", onload);
            document.addEventListener("click", closeHeadshot);
        };

        //Change image and text
        const data = card.dataset;
        expandedImage.addEventListener("load", onload);
        expandedImage.src = data.headshot;
        expandedName.innerText = data.name;
        expandedTitle.innerText = data.titles;
        expandedBio.innerText = data.bio;
        expandedLearnMore.href = data.learnmore;


        //Fade out the other items
        gsap.to(headshots, {
            opacity: 0.3,
            stagger: { amount: 0.7, from: headshots.indexOf(card), grid: "auto" }
        });
        gsap.to(headshots, { blur: 6 });
        activeHeadshot = card;
    }

    function closeHeadshot() {
        document.removeEventListener("click", closeHeadshot);

        //allow scrolling again
        gsap.set('body', { overflow: 'auto' });

        //Record current state
        const state = Flip.getState(expandedContainer);

        //Scale details down so that it's image fits exactly on top of the active headshot
        Flip.fit(expandedContainer, activeHeadshot.querySelector("img"), {
            scale: true,
            fitChild: expandedImage
        });

        //Put the bio container back and then fade in the other headshots

        const tl = gsap.timeline();
        tl.to(expandedBioContainer, { xPercent: 5, opacity: 0, duration: 0.25 })
            .to(headshots, { blur: 0 })
            .to(
                headshots,
                {
                    opacity: 1,
                    stagger: {
                        amount: 0.3,
                        from: headshots.indexOf(activeHeadshot),
                        grid: "auto"
                    }
                },
                0
            );

        Flip.from(state, {
            scale: true,
            duration: 0.5,
            delay: 0.2,
            ease: "power2.inOut",
            absolute: true
        }).to(expandedContainer, { visibility: "hidden" });

        activeHeadshot = null;
    }

    function generateHoverTimeline(target) {
        const tl = gsap.timeline({ paused: true });
        tl.to(target, { yPercent: -2, duration: 0.25, ease: "power2.inOut" });
        return tl;
    }

    //Add click events
    gsap.utils.toArray(".leadershipCard").forEach((item) => {
        item.addEventListener("click", () => {
            expandHeadshot(item);
        });
    });

    gsap.set(".leadershipCard", { autoAlpha: 1 });
    gsap.from(".leadershipCard", {
        onComplete: initHovers,
        opacity: 0,
        yPercent: 30,
        stagger: 0.14,
        scrollTrigger: {
            trigger: ".leadershipContainer",
            start: "top 60%"
        }
    });

    function initHovers() {
        gsap.utils.toArray(".leadershipCard").forEach((item) => {
            const cardTimeline = generateHoverTimeline(item);
            item.addEventListener("mouseenter", () => {
                if (activeHeadshot) {
                    return;
                } else {
                    cardTimeline.play();
                }
            });
            item.addEventListener("mouseleave", () => {
                if (activeHeadshot) {
                    return;
                } else {
                    cardTimeline.reverse();
                }
            });
        });
    }
}

initAboutLeadershipTeam();